import router from './router'
import {auth} from '@/utils/auth'

const whiteList = [
    '/login', '/index', '/findPassword/findPassword', 'NoticeDetail',
    '/register/register', '/register/orderPay', '/register/orderPayOff',
    '/register/officialConfirm', '/register/sealConfirm', '/exp500',
    '/handwriting', 'transfer', '/customerEnterprise/login',
    , '/verifyTruth', '/interfaceDocumentation', '/qys',
    , '/qys/orderPay', '/qys/orderPayOff',
    '/qys/officialConfirm', '/qys/sealConfirm',
    '/customerEnterprise/findPassword', '/openness/home',
    '/about', '/register/operatorAuthentication', '/register/sealChange',
    'physicsSeal', 'authentication', 'operatorAuthentication',
    '/h5/home', '/register/physicsSeal', '/register/success', 'digitalCertificate'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    // 是否已登录
    const token = to.path.includes('customerEnterprise') ? auth.getKqToken() : auth.getToken()
    if (token) {
        if (to.path === '/login' && !to.path.includes('customerEnterprise')) {
            next({path: '/home'})
        } else if (to.path === '/customerEnterprise/login' && to.path.includes('customerEnterprise')) {
            next({path: '/customerEnterprise/home'})
        } else {
            next()
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1 || whiteList.indexOf(to.name) !== -1) {
            next()
        } else {
            if (to.path.includes('customerEnterprise')) {
                next('/customerEnterprise/login')
            } else {
                next(`/index`)
            }
        }
    }
})
